import { Fragment } from 'react';
import { useIntl } from 'react-intl';

import { Modal } from '@calm-web/design-system';

import messages from './messages';
import { Action, Key, Keys, ShortcutList } from './styles';
import { ShortcutHelpModalProps } from './types';

const ShortcutHelpModal = ({ isOpen, onClose }: ShortcutHelpModalProps) => {
	const { formatMessage, formatList } = useIntl();

	const shortcuts = [
		{ action: messages.playPause, keys: [formatMessage(messages.keySpace), 'K'] },
		{ action: messages.skipBack, keys: [formatMessage(messages.keyLeft), 'J'] },
		{ action: messages.skipForward, keys: [formatMessage(messages.keyRight), 'L'] },
		{ action: messages.restart, keys: [formatMessage(messages.keyHome), '0'] },
		{ action: messages.jump, keys: [formatMessage(messages.keyDigits)] },
		{ action: messages.mute, keys: ['M'] },
		{ action: messages.fullscreen, keys: ['F'] },
		{ action: messages.close, keys: [formatMessage(messages.keyEscape)] },
		{ action: messages.help, keys: ['?'] },
	];

	return (
		<Modal isOpen={isOpen} closeModal={onClose} title={formatMessage(messages.title)}>
			<ShortcutList>
				{shortcuts.map(({ action, keys }) => (
					<Fragment key={action.id}>
						<Keys>
							{formatList(
								keys.map(key => <Key key={key}>{key}</Key>),
								{ type: 'disjunction' },
							)}
						</Keys>
						<Action>{formatMessage(action)}</Action>
					</Fragment>
				))}
			</ShortcutList>
		</Modal>
	);
};

export default ShortcutHelpModal;
